"use strict";

class SuperUserViewController {

    constructor($http, $scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSConfirmationService) {
        const self = this;

        self.$http  = $http;
        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.PN_SERVER_URL = SHOWSUITE.PN_SERVER_URL;

        self.USER_STATUS_PENDING = SHOWSUITE.USER_STATUS_PENDING;
        self.USER_STATUS_ACTIVE = SHOWSUITE.USER_STATUS_ACTIVE;
        self.USER_STATUS_INACTIVE = SHOWSUITE.USER_STATUS_INACTIVE;

        self.statuses = {};
        self.statuses[self.USER_STATUS_PENDING] = 'Pending';
        self.statuses[self.USER_STATUS_ACTIVE] = 'Active';
        self.statuses[self.USER_STATUS_INACTIVE] = 'In-active';

        self.rootAccount = {};
        self.rootAccount[0] = 'No';
        self.rootAccount[1] = 'Yes';

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        jQuery('.datepicker').datepicker({
            dateFormat: "yy-mm-dd"
        });

        self.apiOffset = 0;
        self.apiLimit = 10;

        self.searchParams = {};
        self.entry = {};

        self.resetUserModel();
        self.getUsers();
        self.getAgencies();

    }


    getUsers() {
        const self = this;

        self.users = null;

        let url = 'sec/super/users';
        self.searchParams.offset = self.apiOffset;
        self.searchParams.limit = self.apiLimit;

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.searchParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.users = response.data.users;
            self.count = response.data.count;

            _.forEach(self.users, function (user) {
                if (user.status == null) {
                    user.status = 0;
                }
            });

            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        });
    }

    getAgencies() {
        const self = this;

        let url = 'agencies';
        let params = {
            'offset': 0,
            'limit': 100,
            'format': 1
        };

        self.agencies = null;

        self.SSHttpService.getAPIRequest(url, params).then(function (responseObj) {

            if (responseObj instanceof Error) {
                return;
            }

            self.agencies = responseObj.data.agencies;
        });
    }

    getEntryStatus() {
        const self = this;

        if (self.entry.status == null)
            return self.statuses[0];

        return self.statuses[self.entry.status == true ? 1 : 2];
    }
    getEntryRootAccount() {
        const self = this;
        return self.rootAccount[self.entry.root_account ? 1 : 0];
    }

    searchUsers() {
        const self = this;

        self.apiOffset = 0;
        self.selectedPage = 1;
        self.getUsers();
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.getUsers();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.getUsers();
    }

    getStatus(user) {
        const self = this;

        if (!user.status) {
            if (!user.token)
                return "In-active";
            return "Pending";
        }
        return self.statuses[user.status];
    }

    togglePopup() {
        const self = this;

        self.detailsModal = !self.detailsModal;
        jQuery('#UserDetailsPopup').modal(jQuery('#UserDetailsPopup').is(':visible') ? 'hide' : 'show');
    }

    detailsPopup(user) {
        const self = this;

        self.entry = angular.copy(user);

        if (self.statuses[self.entry.status] == 'Pending')
            self.entry.status = null;
        else
            self.entry.status = self.statuses[self.entry.status] == 'Active' ? true : false;
        
        self.entry.root_account = self.entry.root_account == 1 ? true: false; 

        self.errorMessage = null;

        self.maskPhoneNumber(self, 'ctrl.');

        self.togglePopup();
    }

    updateUser() {
        const self = this;

        self.errorMessage = null;

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#UserDetailsPopup'))) {
            return;
        }

        if (!self.entry.first_name || !self.entry.last_name || !self.entry.email) {
            self.errorMessage = 'Please enter valid data. All fields are required.';
            return;
        }

        let url = 'sec/super/users/update';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.entry).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.errorMessage = "Oops! Something went wrong. Please try again.";
                return;
            }

            let entry = response.data.user;
            _.forEach(self.users, function (user) {
                if (user.id == entry.id) {
                    angular.merge(user, entry);
                    return false;
                }
            });

            if (self.entry.reInvite)
                self.SSAlertService.success('User has been re-invited successfully.');
            else
                self.SSAlertService.success('User has been updated successfully.');

            self.togglePopup();

        });
    }

    reInviteUser() {
        const self = this;

        self.entry.reInvite = true;
        self.updateUser();
    }

    /**
     * Opens the Reset Password modal for the supplied user.
     *
     * @param {Object} user The user row whose password is being reset.
     */
    openResetPasswordModal(user) {
        const self = this;

        self.resetPasswordEntry = {
            user: user,
            password: '',
            password_confirmation: ''
        };
        self.resetPasswordErrorMessage = null;

        self.toggleResetPasswordModal = true;
        jQuery('#ResetPasswordPopup').modal('show');
    }

    /**
     * Closes the Reset Password modal and clears its state.
     */
    closeResetPasswordModal() {
        const self = this;

        self.toggleResetPasswordModal = false;
        jQuery('#ResetPasswordPopup').modal('hide');

        self.resetPasswordEntry = {};
        self.resetPasswordErrorMessage = null;
    }

    /**
     * Submits the new password to the server.
     *
     * Calls POST sec/super/users/reset-password with the target user id and
     * the new password. The endpoint is gated by SS_EDIT_USERS on the server
     * (see ShowsuiteServer SuperUserController::resetUserPassword).
     */
    resetUserPassword() {
        const self = this;

        self.resetPasswordErrorMessage = null;

        const entry = self.resetPasswordEntry || {};
        const user = entry.user;
        const password = entry.password;
        const passwordConfirmation = entry.password_confirmation;

        if (!user || !user.id) {
            self.resetPasswordErrorMessage = 'No user selected.';
            return;
        }

        if (!password || !passwordConfirmation) {
            self.resetPasswordErrorMessage = 'Please enter and re-type the new password.';
            return;
        }

        if (password.length < 8) {
            self.resetPasswordErrorMessage = 'Password must be at least 8 characters long.';
            return;
        }

        if (password !== passwordConfirmation) {
            self.resetPasswordErrorMessage = 'Passwords do not match.';
            return;
        }

        const url = 'sec/super/users/reset-password';
        const params = {
            id: user.id,
            password: password
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.resetPasswordErrorMessage = response.message || 'Oops! Something went wrong. Please try again.';
                return;
            }

            self.SSAlertService.success('User password has been reset successfully.');
            self.closeResetPasswordModal();
        });
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;
        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('.tel'), function (i, el) {

            let field = jQuery(el);
            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);

                if (value) {
                    field.intlTelInput('setNumber', value);
                } else {
                    field.val('');
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-warning");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-warning");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        document.getElementById('user_phone1').setCustomValidity("Invalid Contact Number");
                    }
                } else {
                    if (model) {
                        document.getElementById('user_phone1').setCustomValidity("");
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                        jQuery('#phone1-full').val(field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    sendNotificationContainer() {
        const self = this;

        let count = 0;

        self.selected_users.forEach(function (key, userId) {

            if (key) {
                count += 1;
            }
        });
        self.noOfUsersSelected = count;

        self.$timeout(function () {
            $("select.type-select#group-select").niceSelect('update');
        });

        self.usersSendNotifications = !self.usersSendNotifications;
        jQuery('#usersSendNotifications').modal(self.usersSendNotifications ? 'show' : 'hide');
    }

    selectUsers() {
        const self = this;

        let check = self.selected_all_users;

        self.SelectAllUsers = check;

        self.users.forEach(function (user) {
            self.selected_users[user.id] = check;
        });

        self.userSelected = self.checkUserSelected();

    }

    checkAllUsersSelected() {
        const self = this;

        let check = true;
        let count = 0;

        self.users.forEach(function (user) {
            if (!self.selected_users[user.id]) {
                check = false;
                self.selected_all_users = false;
            }
        });
        if (check) {
            self.selected_all_users = true;
        }

        self.userSelected = self.checkUserSelected();

    }

    checkUserSelected() {

        const self = this;

        let count = 0;
        self.selected_users.forEach(function (key, userId) {

            if (key) {
                count += 1;
            }
        });

        if (count > 0) {
            return true;
        } else {
            return false;
        }
    }

    sendNotificationtoUsers() {
        const self = this;


        self.sendNotificationsPram.type_of_message = self.typeSelected;
        self.sendNotificationsPram.device_uuids = [];
        self.noSelectedUsers = 0;

        self.sendNotificationsPram.message = JSON.parse(self.sendNotificationsPram.message);

        self.selected_users.forEach(function (key1, userId1) {
            if (key1) {
                self.users.forEach(function (key2, userId2) {

                    if (key2.id == userId1) {
                        self.sendNotificationsPram.device_uuids.push(key2.device_uuid);
                    }
                })
            }
        });

        let count = 0;

        self.selected_users.forEach(function (key, userId) {

            if (key) {
                count += 1;
            }
        });
        self.noOfUsersSelected = count;


        if(self.selectionBaseNotification == 'true'){
            self.sendNotificationsPram.criteria = true
            self.sendNotificationsPram.role = self.criteriaSelectedRole;
        } else {
            self.sendNotificationsPram.criteria = false
        }

        let url = 'sec/super/notifications/send-message';
        // let url = self.PN_SERVER_URL + '/send-message';

        self.sendNotificationContainer();
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to send this notification?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                loading(true);
                self.SSHttpService.postAPIRequest(url, self.sendNotificationsPram).then(function (response) {
                    loading(false);
                    self.init();

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Notification has been sent successfully.');
                    self.resetUserModel();
                });
            }
        );
    }

    checkCriteria() {
        const self = this;

        if(self.selectionBaseNotification == 'true')
        {
            self.criteriaCheked = true;
        }
        else{
            self.criteriaCheked = false;
        }

        console.log('here');
        console.log(self.criteriaCheked);
    }

    resetUserModel() {
        const self = this;

        self.sendNotificationsPram = {};
        self.selected_users = [];
        self.criteriaCheked = false;
        self.selectionBaseNotification = false;
        self.typeSelected = "transactional";
        self.criteriaSelectedRole = "ALL";
        self.userSelected = self.checkUserSelected();

    }

    roleSelected(role) {
        const self = this;

        if (role == 'ALL') {
            return 'ALL';
        } else if (role == 13) {
            return 'Customer';
        } else if (role == 12) {
            return 'Broker';
        } else if (role == 8) {
            return 'Agency';
        } else if (role == 4) {
            return 'Developer';
        }
    }

}

SuperUserViewController.$inject = ['$http', '$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSConfirmationService'];
app.controller('SuperUserViewController', SuperUserViewController);

